<div [@routeAnimations]="prepareRoute(outlet)" >
    <router-outlet #outlet="outlet"></router-outlet>
</div>

<div id="dialog-container" class="hidden"></div>